export default Object.freeze({
  white: "hsla(0, 0%, 100%, 1)",
  green_0: "hsla(155, 100%, 98%, 1)",
  green_10: "hsla(155, 73%, 92%, 1)",
  green_20: "hsla(155, 71%, 83%, 1)",
  green_30: "hsla(155, 58%, 66%, 1)",
  green: "hsla(155, 49%, 55%, 1)",
  green_70: "hsla(155, 50%, 43%, 1)",
  green_80: "hsla(155, 97%, 27%, 1)",
  green_90: "hsla(155, 97%, 22%, 1)",
  green_100: "hsla(155, 100%, 11%, 1)",
  sky_0: "hsla(202, 100%, 98%, 1)",
  sky_10: "hsla(202, 100%, 94%, 1)",
  sky_20: "hsla(202, 100%, 85%, 1)",
  sky_30: "hsla(202, 100%, 73%, 1)",
  sky: "hsla(202, 100%, 60%, 1)",
  sky_70: "hsla(202, 83%, 49%, 1)",
  sky_80: "hsla(202, 100%, 37%, 1)",
  sky_90: "hsla(202, 100%, 28%, 1)",
  sky_100: "hsla(202, 100%, 15%, 1)",
  blue_0: "hsla(209, 100%, 98%, 1)",
  blue_10: "hsla(209, 100%, 95%, 1)",
  blue_20: "hsla(209, 100%, 87%, 1)",
  blue_30: "hsla(209, 85%, 76%, 1)",
  blue: "hsla(209, 61%, 64%, 1)",
  blue_70: "hsla(209, 55%, 54%, 1)",
  blue_80: "hsla(209, 65%, 43%, 1)",
  blue_90: "hsla(209, 87%, 32%, 1)",
  blue_100: "hsla(209, 100%, 19%, 1)",
  grey_0: "hsla(208, 100%, 99%, 1)",
  grey_10: "hsla(208, 40%, 94%, 1)",
  grey_12: "hsla(210, 33%, 93%, 1)",
  grey_20: "hsla(208, 24%, 87%, 1)",
  grey_26: "hsla(207, 19%, 79%, 1)",
  grey_30: "hsla(209, 16%, 74%, 1)",
  grey: "hsla(204, 11%, 61%, 1)",
  grey_70: "hsla(204, 9%, 50%, 1)",
  grey_80: "hsla(204, 9%, 42%, 1)",
  grey_90: "hsla(216, 14%, 29%, 1)",
  grey_98: "hsla(214, 29%, 19%, 1)",
  grey_100: "hsla(215, 35%, 16%, 1)",
  cyan_0: "hsla(191, 100%, 98%, 1)",
  cyan_10: "hsla(191, 100%, 94%, 1)",
  cyan_20: "hsla(191, 84%, 84%, 1)",
  cyan_30: "hsla(191, 73%, 68%, 1)",
  cyan: "hsla(191, 70%, 53%, 1)",
  cyan_70: "hsla(191, 89%, 39%, 1)",
  cyan_80: "hsla(191, 100%, 30%, 1)",
  cyan_90: "hsla(191, 100%, 24%, 1)",
  cyan_100: "hsla(191, 100%, 13%, 1)",
  teal_0: "hsla(175, 100%, 97%, 1)",
  teal_10: "hsla(175, 81%, 93%, 1)",
  teal_20: "hsla(175, 73%, 83%, 1)",
  teal_30: "hsla(175, 60%, 69%, 1)",
  teal: "hsla(175, 55%, 59%, 1)",
  teal_70: "hsla(175, 79%, 35%, 1)",
  teal_80: "hsla(175, 83%, 28%, 1)",
  teal_90: "hsla(175, 95%, 21%, 1)",
  teal_100: "hsla(175, 100%, 11%, 1)",
  border: "hsla(210, 43%, 95%, 1)",
});
